/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import _ from 'underscore';
import {IStore2} from 'tau/configuration'
import {getSubset} from '../utils'

export interface User {
  globalId: string
  fullName: string
}

export class UserService {
  private userMap = new Map<string, string>()
  private store2: IStore2

  constructor({store2}) {
    this.store2 = store2
  }

  public async getUserNames(userIds: string[]): Promise<Map<string, string>> {
    const idsToFetch = _.uniq(userIds).filter((id) => !this.userMap.has(id))
    const users = await this.store2.findAll<User>(
      `users?select={globalId,fullName}&where=(globalId in [${idsToFetch
        .map((id) => `'${id}'`)
        .join(',')}])`
    )

    users.forEach((user) => this.userMap.set(user.globalId, user.fullName))

    return getSubset(this.userMap, userIds)
  }
}
